import { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { TextArea, LoadingData, ErrorMessage } from "../../ui";

export const FeedbackModal = ({ isOpen, setIsOpen, formProps }) => {
  // Datos del hook ----------------------------------------//
  // States ------------------------------------------------//
  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//
  // Efectos -----------------------------------------------//

  return (
    <Modal show={isOpen} onHide={() => setIsOpen(false)} centered size="sm">
      <Modal.Header closeButton>
        <h5 className="modal-title">
          Cuéntanos porqué no estás de acuerdo con la clasificación ASA
        </h5>
      </Modal.Header>
      <Modal.Body>
        <div className="row gy-3">
          <div className="col-12">
            <TextArea
              label={null}
              sublabel={null}
              placeholder={null}
              validation={formProps.formValidation?.messageValid}
              submit={formProps.validateForm}
              name={"message"}
              value={formProps.formState.message}
              onInputChange={formProps.onInputChange}
              rows={5}
            />
          </div>

          {formProps.isLoading && (
            <div className="col-12">
              <LoadingData />
            </div>
          )}

          {formProps.showErrorMessage && (
            <div className="col-12">
              <ErrorMessage>{formProps.messageText}</ErrorMessage>
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-primary"
          onClick={formProps.onSubmit}
        >
          Enviar
        </button>
      </Modal.Footer>
    </Modal>
  );
};
